"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".resultContent_8d238594{display:table-row}.resultContent_8d238594 .resultItem_8d238594{display:table-cell;vertical-align:bottom}.peoplePickerPersona_8d238594{width:180px}.peoplePickerPersona_8d238594 .ms-Persona-details{width:100%}.peoplePicker_8d238594 .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_8d238594{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}\n" }]);
exports.resultContent = "resultContent_8d238594";
exports.resultItem = "resultItem_8d238594";
exports.peoplePickerPersona = "peoplePickerPersona_8d238594";
exports.peoplePicker = "peoplePicker_8d238594";
exports.peoplePickerPersonaContent = "peoplePickerPersonaContent_8d238594";
//# sourceMappingURL=ExtendedPeoplePicker.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/ExtendedPicker/PeoplePicker/ExtendedPeoplePicker.scss.js
// module id = 992
// module chunks = 0